import React, { useState } from 'react';
import { ImageOnCakeSettings } from '../../../types';
import ImageOnCakeSettingsForm from './ImageOnCakeSettingsForm';
import './ImageOnCakeManagement.css';

interface ImageOnCakeManagementProps {
  settings: ImageOnCakeSettings | null;
  loading?: boolean;
  onUpdateSettings: (settings: Partial<ImageOnCakeSettings>) => void;
}

const ImageOnCakeManagement: React.FC<ImageOnCakeManagementProps> = ({
  settings,
  loading = false,
  onUpdateSettings
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = (updatedSettings: Partial<ImageOnCakeSettings>) => {
    onUpdateSettings(updatedSettings);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  if (loading) {
    return (
      <div className="image-on-cake-management">
        <div className="image-on-cake-management__loading">
          <div className="loading-spinner"></div>
          <p>Loading image on cake settings...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="image-on-cake-management">
      <div className="image-on-cake-management__header">
        <h3>Image on Cake Pricing</h3>
        <p className="image-on-cake-management__description">
          Configure the additional price charged when customers add an edible image to their cake.
        </p>
      </div>

      {isEditing ? (
        <ImageOnCakeSettingsForm
          settings={settings}
          onSubmit={handleSave}
          onCancel={handleCancel}
          loading={loading}
        />
      ) : (
        <div className="image-on-cake-management__display">
          <div className="image-on-cake-settings-card">
            <div className="image-on-cake-settings-card__header">
              <h4>Current Image on Cake Settings</h4>
              <button
                className="btn btn--secondary btn--small"
                onClick={handleEdit}
                disabled={loading}
              >
                Edit Settings
              </button>
            </div>

            <div className="image-on-cake-settings-card__content">
              <div className="image-on-cake-settings-card__row">
                <div className="image-on-cake-settings-card__field">
                  <label>Additional Price</label>
                  <div className="image-on-cake-price">
                    €{settings?.price?.toFixed(2) || '0.00'}
                  </div>
                </div>

                <div className="image-on-cake-settings-card__field">
                  <label>System Status</label>
                  <div className={`system-status system-status--${settings?.isActive ? 'active' : 'inactive'}`}>
                    {settings?.isActive ? 'Active' : 'Inactive'}
                  </div>
                </div>
              </div>

              {settings?.isActive && (
                <div className="image-on-cake-settings-card__preview">
                  <h5>Pricing Preview</h5>
                  <div className="image-on-cake-preview">
                    <div className="image-on-cake-preview__example">
                      <span>Base cake price: €50.00</span>
                      <span>Image on cake: +€{settings.price?.toFixed(2) || '0.00'}</span>
                      <span className="image-on-cake-preview__total">
                        Total: €{(50 + (settings.price || 0)).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageOnCakeManagement;
